import { consumerCarleadCreateWithLicensePlateMapper } from '@wkda/carlead-creation-form';
import { useCreateCarleadForm } from './useCreateCarleadForm';
export function useCreateLicensePlateCarleadForm(params) {
  const defaults = {
    payloadMapper: consumerCarleadCreateWithLicensePlateMapper
  };
  const carleadForm = useCreateCarleadForm([defaults, ...params]);
  return carleadForm;
}